<template>
   <div>reoort</div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/view/report.vue